<template>
	<div class="member_serve width">
		<div class="directory">
			<p><span>会员中心</span></p>
			<ul>
				<li v-for="(item, index) in list" :key="index" @click="$router.replace(item.path)">
					<span>{{item.name}}</span>
					<i class="el-icon-arrow-right"></i>
				</li>
			</ul>
		</div>
		<div class="content">
			<router-view />
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [{
						name: '联合会会员登记表',
						path: '/member/league'
					},
					{
						name: '工作委员会委员登记表',
						path: '/member/committee'
					},
					{
						name: '会员企业名录',
						path: '/member/business'
					},
					{
						name: '会员风采',
						path: '/member/mien'
					},
				]
			};
		},
		mounted() {},
		methods: {},
	};
</script>
<style scoped>
	.member_serve {
		margin: 20px auto;
		margin-bottom: 100px;
		display: flex;
	}

	.directory {
		width: 15%;
	}

	.directory p {
		border-bottom: 1px solid #ddd;
		box-sizing: border-box;
		margin-top: 20px;
	}

	.directory p span {
		display: inline-block;
		padding: 7px 10px;
		font-weight: bold;
		border-bottom: 2px solid #016fb8;
	}

	.directory i {
		margin-left: 10px;
	}

	.directory ul {
		margin-top: 10px;
	}

	.directory ul li {
		background: #ddd;
		margin-top: 4px;
		padding: 10px;
		color: gray;
		font-size: 14px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.directory ul li span:hover {
		color: #016fb8;
		font-weight: bold;
		cursor: pointer;
	}

	.content {
		width: 80%;
		margin-left: 5%;
	}
</style>
